import { render } from "./client_department.vue?vue&type=template&id=40dfbc1a&scoped=true"
import script from "./client_department.vue?vue&type=script&lang=js"
export * from "./client_department.vue?vue&type=script&lang=js"

import "./client_department.vue?vue&type=style&index=0&id=40dfbc1a&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40dfbc1a"]])

export default __exports__